// eslint-disable-next-line require-jsdoc
import React from 'react';
import PropTypes from 'prop-types';
import IndeterminateShort from '@ids/indeterminate-short';
/*
 *IDS Components
 * assests
 * Third party
 * Componenets
 */
import {
  PerforatedAddToCartPricingSection,
  GetStartedCartPricingSection,
  AddToCartPricingSection,
  TaxAddToCartPricingSection,
  AddToCartColorPickerPricingSection,
  BundlePricingSection,
} from './PricingSections/index';

// eslint-disable-next-line require-jsdoc
export const ProductPricingInformation = (props) => {
  const { pageData, loading } = props;

  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <IndeterminateShort theme="quickbooks" />
      </div>
    );
  }

  switch (pageData.Department.PricingInformation.Type) {
    case 'GETSTARTED':
      return <GetStartedCartPricingSection {...props} />;

    case 'PERF01':
      return <PerforatedAddToCartPricingSection {...props} />;

    case 'TAX-01':
    case 'TAX-72':
    case 'TAX-02':
      return <TaxAddToCartPricingSection {...props} />;

    case 'ADDTOCART':
      return <AddToCartPricingSection {...props} />;

    case 'ADDTOCARTCOLORPICKER':
      return <AddToCartColorPickerPricingSection {...props} />;

    case 'BUNDLE':
      return <BundlePricingSection {...props} />;
    case 'PRINT':
    default:
      return <div />;
  }
};

ProductPricingInformation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pageData: PropTypes.object.isRequired,
};
